import { CellTable } from "@/atoms"

export const CellTableCustomTooltip =
  (tooltip: string) => (text: string | React.ReactNode) =>
    CellTable({ tooltip, text })
